// ============================================================
// geoData.js — Chargement lazy des jeux de données volumineux
// ------------------------------------------------------------
// airports.json (~2 Mo) et airlines.json (~270 Ko) ne doivent pas
// gonfler le bundle initial. On les charge via import() dynamique
// (webpack crée des chunks séparés) avec cache en mémoire.
//
//	exports :
//	  - loadAirports() / loadAirlines() : Promise (idempotentes)
//	  - useAirports() / useAirlines()   : hooks React qui re-renderent
//	    le composant une fois les données chargées
// ============================================================

import { useEffect, useState } from "react";

let airportsPromise = null;
let airlinesPromise = null;
let airportsCache = null;
let airlinesCache = null;

export function loadAirports() {
  if (!airportsPromise) {
    airportsPromise = import("../data/airports.json" /* webpackChunkName: "airports" */)
      .then((mod) => {
        airportsCache = mod.default || mod;
        return airportsCache;
      })
      .catch((err) => {
        console.error("Impossible de charger airports.json :", err);
        airportsCache = [];
        return airportsCache;
      });
  }
  return airportsPromise;
}

export function loadAirlines() {
  if (!airlinesPromise) {
    airlinesPromise = import("../data/airlines.json" /* webpackChunkName: "airlines" */)
      .then((mod) => {
        airlinesCache = mod.default || mod;
        return airlinesCache;
      })
      .catch((err) => {
        console.error("Impossible de charger airlines.json :", err);
        airlinesCache = { data: [] };
        return airlinesCache;
      });
  }
  return airlinesPromise;
}

// Accès synchrone une fois le chunk chargé (ou null avant).
export function getAirports() {
  return airportsCache;
}

export function getAirlines() {
  return airlinesCache;
}

// Hook : renvoie les données (null tant que non chargées) et re-rend
// automatiquement le composant lorsqu'elles arrivent.
export function useAirports() {
  const [data, setData] = useState(airportsCache);
  useEffect(() => {
    let active = true;
    loadAirports().then((d) => {
      if (active) setData(d);
    });
    return () => {
      active = false;
    };
  }, []);
  return data;
}

export function useAirlines() {
  const [data, setData] = useState(airlinesCache);
  useEffect(() => {
    let active = true;
    loadAirlines().then((d) => {
      if (active) setData(d);
    });
    return () => {
      active = false;
    };
  }, []);
  return data;
}